import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/(people)/companies/$clientId")({
  beforeLoad: ({ params }) => {
    const { clientId } = params;

    throw redirect({ to: `/companies/overview/${clientId}` });
  },
});
